import styled from 'styled-components';
import { FONTS, Typography } from '@fupa/fupa-uikit';
export const Label = styled(Typography).withConfig({
  componentId: "sc-4f6x3e-0"
})(["&&&{justify-self:left;font-size:", ";align-self:center;padding:", ";}"], FONTS['16'], props => props.padding ? "0 ".concat(props.padding, "px") : 'none');
export const DataEntry = styled.div.withConfig({
  componentId: "sc-4f6x3e-1"
})(["width:100%;justify-self:center;display:flex;justify-content:", ";align-items:center;"], props => {
  var _props$justify;
  return (_props$justify = props.justify) !== null && _props$justify !== void 0 ? _props$justify : 'space-between';
});
export const Action = styled.div.withConfig({
  componentId: "sc-4f6x3e-2"
})(["grid-column:span ", ";justify-self:", ";white-space:nowrap;"], props => {
  var _props$span;
  return (_props$span = props.span) !== null && _props$span !== void 0 ? _props$span : 1;
}, props => {
  var _props$justify2;
  return (_props$justify2 = props.justify) !== null && _props$justify2 !== void 0 ? _props$justify2 : 'start';
});